/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {revokeConsent} from '../api'

export const useMutationRevokeConsent = createReactQueryMutationHook('revokeConsent', revokeConsent)
